import * as React from "react";

import { useTranslation } from "react-i18next";

import { SearchIcon, XIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export interface DataTableToolbarProps {
  search?: string;
  onSearchChange?: (v: string) => void;
  searchPlaceholder?: string;
  filters?: React.ReactNode;
  /**
   * When defined and any filter is active, the toolbar renders a "Reset"
   * link at the right end of the filter row. The page is responsible for
   * defining what "reset" means for its own filters.
   */
  onReset?: () => void;
}

export function DataTableToolbar(props: DataTableToolbarProps) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-wrap items-center gap-2">
      {props.onSearchChange && (
        <div className="relative max-w-sm flex-1">
          <SearchIcon className="text-muted-foreground absolute top-1/2 left-2 size-4 -translate-y-1/2" />
          <Input
            type="search"
            placeholder={
              props.searchPlaceholder ??
              t("components.dataTable.toolbar.searchPlaceholder")
            }
            value={props.search ?? ""}
            onChange={(e) => props.onSearchChange?.(e.target.value)}
            className="pl-8"
          />
        </div>
      )}
      {props.filters}
      {props.onReset && (
        <Button
          variant="ghost"
          size="sm"
          onClick={props.onReset}
          className="text-muted-foreground"
        >
          {t("components.dataTable.toolbar.reset")}
          <XIcon className="ml-1 size-3" />
        </Button>
      )}
    </div>
  );
}
